const SPACING_CONFIG = {
  top: {
    //"m-Image": "m",
  },
  bottom: {
    //"m-Image": "xs",
  },
}
// possible return values: "xs", "s", "m", "l", "xl"

export function defaultSpacingTop(moduleName) {
  let config = SPACING_CONFIG

  let spacing =
    config && config.top && config.top[moduleName]
      ? config.top[moduleName]
      : null

  return spacing
}

export function defaultSpacingBottom(moduleName) {
  let config = SPACING_CONFIG

  let spacing =
    config && config.bottom && config.bottom[moduleName]
      ? config.bottom[moduleName]
      : null
  return spacing
}
